function range(size: number, startAt: number = 0): ReadonlyArray<number> {
  return Array.from({ length: size }, (v, k) => startAt + k);
}

// OBS major constant to be refactored.
const timeHorizonInYears = 30;

export const yearList = range(timeHorizonInYears, new Date().getFullYear());
